
const { ccclass, property } = cc._decorator;

enum RotateType {
    Normal = 0,
    RotationY = 1,
    RotationX = 2,
}

@ccclass
export default class SimpleRotation extends cc.Component {

    @property(cc.Integer)
    angle: number = 400; //转动角度的速度

    @property({ type: cc.Enum(RotateType) })
    rotationType: RotateType = RotateType.Normal

    protected update(dt: number) {
        if (this.rotationType == RotateType.Normal) {
            this.node.angle -= this.angle * dt;            
        } else if (this.rotationType == RotateType.RotationY) {
            this.node.rotationY += this.angle * dt;
        } else if (this.rotationType == RotateType.RotationX) {
            this.node.rotationX += this.angle * dt;
        }
    }
}
